import { set } from 'date-fns';
import { Schedule } from '@root/globalTypes';
import { UsersSchedules } from '@services/schedules/internal/types';
import { WorkloadBasicForeman } from '@services/workload/calendar/types';
import { TimeRange } from '@components/scheduling/timeRangePicker/types';
import { toTenantDate } from '@utils/timeZone';
import { ResourceFilters, TimeWindow } from './types';

export const toForeman = ({
  id,
  fullName,
  discardedAt,
  crewMembers,
  specialties,
}: UsersSchedules): WorkloadBasicForeman => ({
  id,
  fullName,
  discardedAt,
  crewMembers,
  specialties: specialties.map(({ name, value }) => ({ name, value })),
});

const atMinutes = (day: Date, minutes: number) =>
  set(day, { hours: Math.floor(minutes / 60), minutes: minutes % 60, seconds: 0, milliseconds: 0 });

export const toWindow = (day: Date, { start, end }: TimeRange): TimeWindow => ({
  start: +atMinutes(day, start),
  end: +atMinutes(day, end),
});

const range = ({ startsAt, endsAt }: Schedule) => [+toTenantDate(startsAt), +toTenantDate(endsAt)];

export const overlaps = (window: TimeWindow, schedules: Schedule[]) =>
  schedules.some((item) => {
    const [start, end] = range(item);
    return start < window.end && window.start < end;
  });

export const hasConflict = (current: Schedule | undefined, schedules: Schedule[]) => {
  if (!current) return false;
  const [start, end] = range(current);
  return overlaps({ start, end }, schedules);
};

export const toggleFilter = (
  filters: ResourceFilters,
  key: keyof ResourceFilters,
): ResourceFilters => {
  const next = { ...filters, [key]: !filters[key] };
  if (key === 'available' && next.available) next.onSchedule = false;
  if (key === 'onSchedule' && next.onSchedule) next.available = false;
  return next;
};

export const isShowAll = ({ qualified, available, onSchedule }: ResourceFilters) =>
  !qualified && !available && !onSchedule;

export const matchesSearch = (value: string, search: string) =>
  !search.trim() || value.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase());

export const roundHours = (minutes: number) => Math.round((minutes / 60) * 100) / 100;
